function App() {
  return (
    <div className="App">
      <h1>La nouvelle application a-dev.fr arrive tres prochainement. Rejoignez le <a href="https://discord.gg/KQDcjZGxtq" target="_blank">discord</a> pour etre tenu informer</h1>
    </div>
  );
}

export default App;
